import {
  ChangeDetectionStrategy, Component, Input,
} from '@angular/core'

@Component({
  selector: 'address[kb-footer-address]',
  templateUrl: './footer-address.component.html',
  styleUrls: ['./footer-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FooterAddressComponent {
  @Input({ required: true }) public heading!: string
}
